import axios from "../../axiosClientDMS";

export const getSimCardData = async (
  PageNumber: any,
  pageSize: any,
  SortBy: any,
  SortDirection: any,
  TcCode: any,
  SiteCode: any,
  BlockCode: any,
  SearchText: any,
  signal: any,
) => {
  const res = await axios.get(`/dmsapp/SimCard/getall`, {
    params: {
      PageNumber,
      pageSize,
      SortBy,
      SortDirection,
      TcCode,
      SiteCode,
      BlockCode,
      SearchText,
    },
    signal,
  });

  return res?.data;
};
